import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringLength',
  standalone: true,
})
export class StringLengthPipe implements PipeTransform {
  transform(value: string): number {
    return new DOMParser().parseFromString(value, 'text/html').body.textContent.length;
  }
}
